export const time = {
  second: {
    middle: 'sec.',
    short: 's.'
  }
};
